<style lang="less" scoped>
.title{
    display: inline-block;
    text-align: right;
}
.space-around{
    justify-content: space-around;
}
.space-between{
    margin:10px;
    justify-content: space-between;
}
.finance-report-child-div{
    width:330px;
    height:150px;
    margin-top:10px;
    background-color: #EBEEF5;
}
.report-header-div{
    margin:12px 20px;
    border-bottom: solid 1px;
}
.report-mes-div{
    margin-bottom:20px;
}
.report-mes-div div{
    text-align: center;
    height:30px;
}
.report-mes-title{
    margin-right:16px;
}
.report-btn{
    width:100px;
    height:30px;
}
.line-title{
    width:10%;
    font-size: 14px;
    text-align: center;
    padding-top: 50px;
} 
.report-table {
    font-family: verdana, arial, sans-serif;
    font-size: 14px;
    color: #333333;
    border-width: 1px;
    border-color: #666666;
    border-collapse: collapse;
}
.report-table td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #666666;
    text-align: center;
}
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">运营商详情</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <div>
                    <div class="flex space-between">
                        <div><span class="title">运营商：</span>{{dealerInfo.dealerNanme}}</div>
                        <div><span class="title">社会统一组织机构代码：</span>{{dealerInfo.organizeNo}}</div>
                        <div><span class="title">创建时间：</span>{{dealerInfo.createdWhen}}</div>
                    </div>
                    <div class="flex space-between">
                        <div><span>公司联系人：</span>{{dealerInfo.contactName}}</div>
                        <div><span>联系人职务：</span>{{dealerInfo.contactPosition}}</div>
                        <div><span>公司电话：</span>{{dealerInfo.contactPhone}}</div>
                    </div>
                    <div class="flex space-between">
                        <div><span>运营商合作协议：</span><a href="/api/v1/files/corp/file/159340269313344.xlsx">合作协议下载</a></div>
                        <div><span>合作协议概述：</span>{{dealerInfo.contactSummary}}</div>
                        <div><span>运营商备注：</span>{{dealerInfo.dealerRemark}}</div>
                    </div>
                </div>
                <el-divider></el-divider>
                <div>
                    <div>设备概要</div>
                    <div class="flex space-around">
                        <div><span>电站数量：</span>{{dealerInfo.stationCount}}</div>
                        <div><span>电桩数量：</span>{{dealerInfo.pileCount}}</div>
                        <div><span>离网：</span>{{dealerInfo.offLineCount}}</div>
                        <div><span>故障：</span>{{dealerInfo.errorCount}}</div>
                        <div><span>申请维修：</span>{{dealerInfo.repairCount}}</div>
                    </div>
                </div>
                <el-divider></el-divider>
                <div>
                    <div>财务报表</div>
                    <div class="flex  space-around">
                        <div class="finance-report-child-div">
                            <div class="report-header-div">提现</div>
                            <div class="report-mes-div">
                                <div><span class="report-mes-title">待提现金额：</span>{{detailForm.unCashOutFee}}元</div>
                                <div><span class="report-mes-title">已提现金额：</span>{{detailForm.cashOutedFee}}元</div>
                                <div><span class="report-mes-title">未入账金额：</span>{{detailForm.uncheckFee}}元</div>
                            </div>
                        </div>
                        <div class="finance-report-child-div">
                            <div class="report-header-div">合计订单总览</div>
                            <div class="report-mes-div">
                                <div><span class="report-mes-title">订单收入：</span>{{detailForm.actFeeAll}}元</div>
                                <div><span class="report-mes-title">充电量：</span>{{detailForm.chargeValAll}}kW·h</div>
                                <div><span class="report-mes-title">订单量：</span>{{detailForm.orderCountAll}}单</div>
                            </div>
                        </div>
                        <div class="finance-report-child-div">
                            <div class="report-header-div">桩到家订单（线上订单）</div>
                            <div class="report-mes-div">
                                <div><span class="report-mes-title">订单收入：</span>{{detailForm.actFeeOnLine}}元</div>
                                <div><span class="report-mes-title">充电量：</span>{{detailForm.chargeValOnLine}}kW·h</div>
                                <div><span class="report-mes-title">订单量：</span>{{detailForm.orderCountOnLine}}单</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex  space-around">
                        <div class="finance-report-child-div">
                            <div class="report-header-div">客户金额</div>
                            <div class="report-mes-div">
                                <div><span class="report-mes-title">客户消费金额：</span>{{detailForm.custConsume}}元</div>
                                <div><span class="report-mes-title">客户度电消费：</span>{{detailForm.allChargeElectric}}度</div>
                                <div><span class="report-mes-title">累计客户度电：</span>{{detailForm.allAddElectric}}度</div>
                            </div>
                        </div>
                        <div class="finance-report-child-div">
                            <div class="report-header-div">平台服务费</div>
                            <div class="report-mes-div">
                                <div><span class="report-mes-title">服务费：</span>{{detailForm.serviceFee}}元</div>
                                <div><span class="report-mes-title">服务费减免（已使用）：</span>{{detailForm.serviceFreeFee}}元</div>
                                <div><span class="report-mes-title">服务费减免（未使用）：</span>{{detailForm.serviceUnFreeFee}}元</div>
                            </div>
                        </div>
                        <div class="finance-report-child-div">
                            <div class="report-header-div">自营订单（线下订单）</div>
                            <div class="report-mes-div">
                                <div><span class="report-mes-title">订单收入：</span>{{detailForm.actFeeOffLine}}元</div>
                                <div><span class="report-mes-title">充电量：</span>{{detailForm.chargeValOffLine}}kW·h</div>
                                <div><span class="report-mes-title">订单量：</span>{{detailForm.orderCountOffLine}}单</div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-divider></el-divider>
                <div>
                    <div class="flex" style="margin-bottom:10px;line-height:30px;">
                        <div>经营状况</div>
                        <div class="flex-1"></div>
                        <div class="flex">
                            <!-- <el-button class="report-btn" size="small">今日</el-button> -->
                            <el-button class="report-btn" size="small" @click="getDayTableData()">近七日</el-button>
                            <el-button class="report-btn" size="small" @click="getMonthTableData()">本月</el-button>
                            <el-button class="report-btn" size="small" @click="getAllTableData()">本年度</el-button>
                        </div>
                    </div>
                    <table class="report-table" width="100%">
                        <tr>
                            <td></td>
                            <td>合计订单（元）</td>
                            <td>桩到家订单（元）</td>
                            <td>自营订单（元）</td>
                            <td>充电量（kW·h)</td>
                            <td>用户量（人）</td>
                            <td>订单量（单）</td>
                            <td>服务费（元）</td>
                            <td>实际收入（元）</td>
                        </tr>
                        <tr>
                            <td>本期</td>
                            <td>{{thisData.actFeeAll}}</td>
                            <td>{{thisData.actFeeOnLine}}</td>
                            <td>{{thisData.actFeeOffLine}}</td>
                            <td>{{thisData.chargeValAll}}</td>
                            <td>{{thisData.custCount}}</td>
                            <td>{{thisData.orderCountAll}}</td>
                            <td>{{thisData.serviceFeeAll}}</td>
                            <td>{{thisData.actInComeAll}}</td>
                        </tr>
                        <tr>
                            <td>上期</td>
                            <td>{{lastData.actFeeAll}}</td>
                            <td>{{lastData.actFeeOnLine}}</td>
                            <td>{{lastData.actFeeOffLine}}</td>
                            <td>{{lastData.chargeValAll}}</td>
                            <td>{{lastData.custCount}}</td>
                            <td>{{lastData.orderCountAll}}</td>
                            <td>{{lastData.serviceFeeAll}}</td>
                            <td>{{lastData.actInComeAll}}</td>
                        </tr>
                        <tr>
                            <td>变化趋势</td>
                            <td>{{trendData.actFeeAll}}%</td>
                            <td>{{trendData.actFeeOnLine}}%</td>
                            <td>{{trendData.actFeeOffLine}}%</td>
                            <td>{{trendData.chargeValAll}}%</td>
                            <td>{{trendData.custCount}}%</td>
                            <td>{{trendData.orderCountAll}}%</td>
                            <td>{{trendData.serviceFeeAll}}%</td>
                            <td>{{trendData.actInComeAll}}%</td>
                        </tr>
                    </table>
                </div>
                <el-divider></el-divider>
                <div>
                    <div class="flex">
                        <div class="flex-1"></div>
                        <el-select v-model="lineData.sourseType" placeholder="请选择" size="small" style="margin-right:10px;">
                            <el-option label="合计订单"  value="00"></el-option>
                            <el-option label="桩到家订单（线上订单）" value="02"></el-option>
                            <el-option label="自营订单（线下订单）" value="01"></el-option>
                        </el-select>
                        <el-button class="report-btn" size="small" @click="getOtherLineData(7)">近七日</el-button>
                        <el-button class="report-btn" size="small" @click="getOtherLineData(30)">本月</el-button>
                        <el-button class="report-btn" size="small" @click="getOtherLineData(365)">本年度</el-button>
                    </div>
                    <div class="flex">
                        <div class="line-title">{{lineTitle}}订单金额</div>
                        <echarts-line v-if="otherFlag" :lineId="orderAmount" :yUnit="unit.yuan" :data="orderFee"></echarts-line>
                    </div>
                    <div class="flex">
                        <div class="flex-1"></div>
                        <el-button class="report-btn" size="small" @click="getOtherLineData(7)">近七日</el-button>
                        <el-button class="report-btn" size="small" @click="getOtherLineData(30)">本月</el-button>
                        <el-button class="report-btn" size="small" @click="getOtherLineData(365)">本年度</el-button>
                    </div>
                    <div class="flex">
                        <div class="line-title">{{lineTitle}}充电量</div>
                        <echarts-line v-if="otherFlag" :lineId="chargingCapacity" :yUnit="unit.kW" :data="chargeSum"></echarts-line>
                    </div>
                    <div class="flex">
                        <div class="flex-1"></div>
                        <el-select v-model="lineData.sourseType" placeholder="请选择" size="small" style="margin-right:10px;">
                            <el-option label="合计订单"  value="00"></el-option>
                            <el-option label="桩到家订单（线上订单）" value="02"></el-option>
                            <el-option label="自营订单（线下订单）" value="01"></el-option>
                        </el-select>
                        <el-button class="report-btn" size="small" @click="getOtherLineData(7)">近七日</el-button>
                        <el-button class="report-btn" size="small" @click="getOtherLineData(30)">本月</el-button>
                        <el-button class="report-btn" size="small" @click="getOtherLineData(365)">本年度</el-button>
                    </div>
                    <div class="flex">
                        <div class="line-title">{{lineTitle}}订单量</div>
                        <echarts-line v-if="otherFlag" :lineId="orderQuantity" :yUnit="unit.dan" :data="orderNum"></echarts-line>
                    </div>
                    <div class="flex">
                        <div class="flex-1"></div>
                        <el-button class="report-btn" size="small" @click="getCustLineData(0)">近七日</el-button>
                        <el-button class="report-btn" size="small" @click="getCustLineData(1)">本月</el-button>
                        <el-button class="report-btn" size="small" @click="getCustLineData(2)">本年度</el-button>
                    </div>
                    <div class="flex">
                        <div class="line-title">{{lineTitle}}充电用户</div>
                        <echarts-line v-if="otherFlag" :lineId="chargingUser" :yUnit="unit.ren" :data="custNum"></echarts-line>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    import echartsLine from './echarts-line';
    export default {
        components: {
            echartsLine,
        },
        data() {
            return {
                pageConfig,
                editFlag:false,
                // 默认值设置
                detailForm: {},
                lineTitle: '近七日',
                custLineTitle: '近七日',
                orderAmount:'orderAmount',
                chargingCapacity:'chargingCapacity',
                orderQuantity:'orderQuantity',
                chargingUser:'chargingUser',
                unit:{
                    yuan:'元',
                    kW:'kW',
                    dan:'单',
                    ren:'人'
                },
                orderFee:{
                    xAxis:[],
                    thisData:[],
                    lastData:[]
                },
                chargeSum:{
                    xAxis:[],
                    thisData:[],
                    lastData:[]
                },
                orderNum:{
                    xAxis:[],
                    thisData:[],
                    lastData:[]
                },
                custNum:{
                    xAxis:[],
                    thisData:[],
                    lastData:[]
                },
                flag:false,
                otherFlag:false,
                lineData:{
                    sourseType:"00"
                },
                lastData:{},
                thisData:{},
                trendData:{},
                dealerInfo:{},
            }
        },
        methods: {
            init() {
                if(this.$store.state.editId){
                    this.editFlag = true;
                    this.getFormInfo();
                    this.getCustLineData(0);
                    this.getDealerInfo();
                    this.getOtherLineData(7);
                }
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                let obj = {}
                    obj.dealerNo = _.$store.state.editId;//'DEAL1543895439624';//;
                    _.$U.showLoading(_);
                _.$H.post(_,_.$A.dealer.rpt,obj).then(res => {
                     _.detailForm = res.data.data;
                     _.thisData = _.detailForm.data7Day.thisData;
                     _.lastData = _.detailForm.data7Day.lastData;
                     _.trendData = _.detailForm.data7Day.trendData;
                     _.$U.hideLoading(_);
                });
            },
            getDealerInfo(){
                let _ = this;
                let obj = {}
                    obj.dealerNo = _.$store.state.editId;
                    _.$U.showLoading(_);
                _.$H.post(_,_.$A.dealer.rptinfo,obj).then(res => {
                     _.dealerInfo = res.data.data;
                     _.$U.hideLoading(_);
                });

            },
            getDayTableData(){
                let _ = this;
                _.thisData = _.detailForm.data7Day.thisData;
                _.lastData = _.detailForm.data7Day.lastData;
                _.trendData = _.detailForm.data7Day.trendData;
            },
            getMonthTableData(){
                let _ = this;
                _.thisData = _.detailForm.dataMonth.thisData;
                _.lastData = _.detailForm.dataMonth.lastData;
                _.trendData = _.detailForm.dataMonth.trendData;
            },
            getAllTableData(){
                let _ = this;
                _.thisData = _.detailForm.dataAll.thisData;
                _.lastData = _.detailForm.dataAll.lastData;
                _.trendData = _.detailForm.dataAll.trendData;
            },
            getOtherLineData(chartDateType){
                let _ = this;
                if(chartDateType == 7){
                    _.lineTitle = "近七日";
                }else if(chartDateType == 30){
                    _.lineTitle = "本月";
                }else{
                    _.lineTitle = "本年度";
                }
                _.lineData.dealerNo = 'DEAL1543895439624';//_.$store.state.editId;
                _.lineData.chartDateType = chartDateType;
                _.$U.showLoading(_);
                _.otherFlag = false;
                _.$H.post(_,_.$A.dealer.rptchart,_.lineData).then(res => {
                    res.data.data.rptChartMap.thisData.forEach((item,index) => {
                        _.orderFee.thisData.push(item.actFee);
                        _.orderFee.xAxis.push(index+1+'');
                        _.chargeSum.thisData.push(item.chargeVal);
                        _.chargeSum.xAxis.push(index+1+'');
                        _.orderNum.thisData.push(item.orderCount);
                        _.orderNum.xAxis.push(index+1+'');
                    })
                    res.data.data.rptChartMap.lastData.forEach((item,index) => {
                        _.orderFee.lastData.push(item.actFee);
                        _.chargeSum.lastData.push(item.chargeVal);
                        _.orderNum.lastData.push(item.orderCount);
                    })
                    _.otherFlag = true;
                    _.$U.hideLoading(_);
                });
            },
            getCustLineData(timeType){
                let _ = this;
                if(timeType == 0){
                    _.custLineTitle = "近七日";
                }else if(timeType == 1){
                    _.custLineTitle = "本月";
                }else{
                    _.custLineTitle = "本年度";
                }
                _.custNum.xAxis = [];
                _.custNum.thisData = [];
                _.custNum.lastData = [];
                let obj = {};
                obj.timeType = timeType;
                _.flag = false;
                _.$U.showLoading(_);
                _.$H.get(_,_.$A.dealer.custlinedata,obj).then(res => {
                    res.data.data.forEach(item => {
                        if(item.dayType == 0){
                            _.custNum.thisData.push(item.userCount);
                        }else{
                            _.custNum.lastData.push(item.userCount);
                        }
                    })
                    if(_.custNum.thisData.length > _.custNum.lastData.length){
                        _.custNum.thisData.forEach((item,index) => {
                            _.custNum.xAxis.push(index+1+'');
                        })
                    }else{
                        _.custNum.lastData.forEach((item,index) => {
                            _.custNum.xAxis.push(index+1+'');
                        })
                    }
                     _.flag = true;
                    _.$U.hideLoading(_);
                });
            },
        },
        mounted() {
            this.init();
        }
    }
</script>